import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import theme from "../../../theme";
import {getCMSConfig, getCMSSettings, getCMSSlot} from "tools/cmsBlockSettings";
import Image from 'next/image';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import TextContent from "../text/text-content";

const useStyles = makeStyles({
	wrapper: {
		display: 'flex',
		alignItems: 'stretch',
		'&.blackweek-dotd': {
			'& .imageWrapper': {
				padding: 30,
				backgroundColor: 'transparent',
				[theme.breakpoints.up('md')]: {
					padding: 50,
				}
			}
		},
        '&.flower-boutique': {
            gap: '10px',
            flexWrap: 'nowrap',
            [theme.breakpoints.down('sm')]: {
                flexWrap: 'wrap',
            }
        },
	},
	imageWrapper: {
		position: 'relative',
		background: theme.palette.primary.color,
		display: 'block'
	},
	text: {
		display: 'flex',
        position: 'relative',
		[theme.breakpoints.down('sm')]: {
			marginTop: 40
		},
        '.flower-boutique &': {
            '--dark-green': '#234b40',
            '--light-green': '#1d4239',
            background: 'var(--dark-green)',
            backgroundImage: 'repeating-linear-gradient(to right, var(--dark-green) 0px, var(--dark-green) 40px, var(--light-green) 40px, var(--light-green) 41px, var(--dark-green) 41px, var(--light-green) 45px, var(--light-green) 45px, var(--dark-green) 46px), linear-gradient(to bottom, var(--dark-green), var(--dark-green))',
            backgroundPosition: 'center',
            backgroundSize: '200%',
            padding: '40px 0',
            margin: '0',
            [theme.breakpoints.down('sm')]: {
                margin: '10px 0 0 0',
            },
        },
        '.flower-boutique &:before': {
            content: '""',
            position: 'absolute',
            inset: '15px',
            backgroundColor: '#a6854c',
            background: 'linear-gradient(#8c764b, #a6854c)',
            zIndex: 20,
            mask: `
                    radial-gradient(50px at 50px 50px,#0000 calc(98% - 10px),#000 calc(100% - 10px) 98%,#0000) -50px -50px,
                    linear-gradient(90deg,#000 20px,#0000 0) -10px 50% /100% calc(100% - 100px + 10px) repeat-x,
                    linear-gradient(      #000 20px,#0000 0) 50% -10px/calc(100% - 100px + 10px) 100% repeat-y;
                `,
            [theme.breakpoints.down('sm')]: {
                inset: '10px 7px',
                mask: `
                    radial-gradient(30px at 30px 30px,#0000 calc(98% - 6px),#000 calc(100% - 6px) 98%,#0000) -30px -30px,
                    linear-gradient(90deg,#000 12px,#0000 0) -6px 50% /100% calc(100% - 60px + 6px) repeat-x,
                    linear-gradient(      #000 12px,#0000 0) 50% -6px/calc(100% - 60px + 6px) 100% repeat-y;

                `,
            }
        },
	},
	content: {
		margin: '0 auto',
		padding: '0 30px',
		width: '100%',
		maxWidth: 500,
        position: 'relative',
		'& h2': {
			marginBottom: 10,
			lineHeight: 1,
            '.flower-boutique &': {
                color: '#8c764b',
                fontSize: '25px',
            }
		},
        '& p': {
            '.flower-boutique &': {
                color: '#fff !important',
            }
        },
		'.stores-text &': {
			'& h3': {
				fontFamily: theme.typography.h4.fontFamily,
				fontSize: 12,
    			fontWeight: 500,
    			textTransform: 'uppercase'
			},
			'& p': {
				margin: '5px 0 0 0',
			},
			[theme.breakpoints.down('sm')]: {
				marginTop: 20,
				padding: 0,
			}
		},
		'.wide-content &': {
			maxWidth: 700
		},

	}
}, {name: 'ImageSideText'});

export default function ImageSideText({block, slots, category}) {
	const CMSSettings = getCMSSettings(block);
	const classes = useStyles();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const text = getCMSSlot('text', slots);
	const image = getCMSSlot('image', slots);
	const isRight = block.type === 'right-image-side-text';

	function getImage(slot) {
		let media = slot.data.media;
		let config = slot.translated.config;

		if(!media) {
			return {
				src: ' ',
				width: 0,
				height: 0
			}
		}

		let returnObject = {
			src: media.url
		};

		returnObject.layout = 'responsive';
		returnObject.width = media.metaData.width;
		returnObject.height = media.metaData.height;

		return returnObject;
	}

	function getOpacity(image) {
		return getCMSConfig('opacity', image.config);
	}

	return (
		<Grid style={{
				...CMSSettings.styles,
			}} container>
			<Grid xs={12} item>
				<Grid className={[classes.wrapper, CMSSettings.class].join(' ')} alignItems="center" direction={isRight && !isMobile ? 'row-reverse' : 'row'} container>
					<Grid xs={12} md={6} item>
						<div className={[classes.imageWrapper, 'imageWrapper'].join(' ')} style={{opacity: getOpacity(image)}}>
								<Image {...getImage(image)} alt={category.metaTitle || category.name || 'Newport Image'} className={[classes.image, 'image'].join(' ')} unoptimized/>
						</div>
					</Grid>
					<Grid className={classes.text} xs={12} md={6} item>
						<div className={classes.content} style={{alignSelf: text.config.verticalAlign.value}}>
							<TextContent content={text.data.content} isVariant={true}/>
						</div>
					</Grid>
				</Grid>
			</Grid>

		</Grid>
	);
}
